import React from "react";
import Image from "next/image";
import BackToCartIcon from "../cartDrawer/backToCartIcon.svg";
import { ScheduledDateDropdown } from "../scheduledDateDropdown/scheduledDateDropdown";
import { ScheduledTimeDropdown } from "../scheduledTimeDropdown/scheduledTimeDropdown";
import { PrimaryButton } from "../button/primaryButton";

export const RestaurantCartScheduledOrderForm = ({
  merchant,
  businessHours,
  handleBackToCart,
  scheduleDate,
  setScheduleDate,
  allDaysEmpty,
  scheduleTime,
  setScheduleTime,
  merchantColor,
  handleConfirmScheduledOrder,
  orderType,
}: any) => {
  return (
    <div className="flex flex-col h-full p-4">
      <div className="pt-4 flex flex-row gap-2">
        <button
          onClick={() => {
            handleBackToCart();
          }}
          className="text-gray-600 hover:text-gray-900"
        >
          <Image
            src={BackToCartIcon.src}
            height={17}
            width={17}
            alt="back to cart"
          />
        </button>
        <h2 className="text-xl font-bold">Schedule Your Order</h2>
      </div>
      <div className="py-4">
        <ScheduledDateDropdown
          scheduleDate={scheduleDate}
          setScheduleDate={setScheduleDate}
          scheduleDateRange={merchant?.scheduledOrdering?.maxDays - 1}
          setScheduleTime={setScheduleTime}
          businessHours={businessHours}
          timezone={merchant.timezone}
          leadTime={merchant.leadTime}
        />
      </div>
      {businessHours && !allDaysEmpty && (
        <div className="py-4">
          <ScheduledTimeDropdown
            scheduleTime={scheduleTime}
            setScheduleTime={setScheduleTime}
            businessHours={businessHours}
            scheduleDate={scheduleDate}
            leadTime={merchant.leadTime}
            timezone={merchant.timezone}
            orderType={orderType}
          />
        </div>
      )}
      <div className="mt-auto pb-4 flex gap-4">
        <PrimaryButton
          style={{
            backgroundColor:
              scheduleTime.displayValue == "" ? "#C7C7C7" : merchantColor,
          }}
          className="bg-black text-white font-bold py-2 rounded-md w-full h-14 disabled:bg-[#C7C7C7]"
          onClick={handleConfirmScheduledOrder}
          disabled={scheduleTime.displayValue == ""}
        >
          <p className="text-xl font-medium">Confirm</p>
        </PrimaryButton>
      </div>
    </div>
  );
};
